module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABAElEQVQ4jbXTMWpCQRgE4IelZSDBxlS5iOQEFrmB1kKKnMQrSMoHCQgWgn0CtskBbCNoYgrBL80GHv/bp0nhVLsz8w+zP2xRnBNoY6GO8X9CXiuDW5SYhcDRqZDvZHxs0FtYJU95qsntH1pPk7cfhXZsght0KvdLXFXue4hBi0himMKv0U3nYUX/5XrVIdiGoAe8VBa8jEtO/DwSZTB9YIND0jfYZ4J2kZhlGt3jDe/pnGu0jkTcUa7RVyZoUiXGiWwVAXjCc4a/SzOdKMAqMzDAIMPDIfIFRkmc1sS69zN5L5oMZTLs0T3yHE79APQdx6GxSUNgD3PssMaktthz4AdgIfKLQ9GozwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/refund1.png
// module id = aC8/
// module chunks = 1